import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Form, FormControl, InputGroup, Modal, Row, Table } from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { GlobalContext } from "../Context/globalContext";
import { GetUsersApi, SendNotification, GetTimeZones } from "../Services/userServices";
import Pagination from "react-js-pagination";
import Swal from "sweetalert2";

export const Users = () => {

    const globalContext = useContext(GlobalContext);
    const [query] = useSearchParams();
    const navigate = useNavigate();
    const [page, set_page] = useState(1);
    const [count, set_count] = useState(0);
    const [data, set_data] = useState([]);
    const [availableTimezone, setAvailableTimezone] = useState([]);
    const [selectedTimezone, setSelectedTimezone] = useState("all");
    const [deviceToken, setDeviceToken] = useState('');
    const [congoModal, setCongoModal] = useState(false);
    const [show, setShow] = useState(false);
    const [message, setMessage] = useState('');
    const [title, setTitle] = useState('');
    const [search, setSearch] = useState('');

    useEffect(() => {
        getAllTimezones();
    }, [])

    useEffect(() => {
        if (query != '' && query.get('page') != '') {
            var current_page = query.get('page')
            getUser(current_page, search);
            set_page(parseInt(current_page))
        }
        else {
            navigate(`/users?page=${1}`)
        }
    }, [query])

    const getAllTimezones = () => {
        GetTimeZones().then(res => {
            setAvailableTimezone(res.data.data.sort());
        }).catch(err => {
            console.log("Error getting timezones: ", err);
        })
    }

    const getUser = (page, search) => {
        globalContext.setLoader(true);
        GetUsersApi(page, search).then(res => {
            globalContext.setLoader(false);
            set_data(res.data.data);
            set_count(res.data.total_count);
        }).catch(err => {
            globalContext.setLoader(false);
            if (err.response.status == 401) {
                sessionStorage.clear();
                globalContext.setLoggedIn(false);
                navigate('/');
                setTimeout(() => { toast.error('Session Expired!'); }, 500);
                return false
            }
            toast.error(err.response.data.message)
        })
    }

    const sendMessage = () => {
        if (title.trim() == '') {
            toast.error("Please enter notification title")
            return false
        }
        else if (message.trim() == '') {
            toast.error("Please enter notification message")
            return false
        }
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Send Notification'
        }).then((result) => {
            if (result.isConfirmed) {
                var params = {
                    'type': deviceToken,
                    'time_zone': selectedTimezone,
                    'title': title,
                    'message': message
                }
                globalContext.setLoader(true);
                SendNotification(params).then(res => {
                    globalContext.setLoader(false);
                    closeModal();
                    Swal.fire(
                        'Delivered!',
                        'Notification has been sent successfully.',
                        'success'
                    )
                }).catch(err => {
                    globalContext.setLoader(false);
                    if (err.response.status == 401) {
                        sessionStorage.clear();
                        globalContext.setLoggedIn(false);
                        navigate('/');
                        setTimeout(() => { toast.error('Session Expired!'); }, 500);
                        return false
                    }
                    toast.error(err.response.data.message)
                })
            }
        })
    }

    const closeModal = () => {
        setShow(false);
        setCongoModal(false);
        setDeviceToken('');
        setTitle('');
        setSelectedTimezone("all")
        setMessage('');
    }

    const handleSearch = (search) => {
        setSearch(search)
        getUser(1, search)
    }

    return (
        <main id="main" className="main">
            <div className="pagetitle">
                <h1>Users Points</h1>
                <Row>
                    <Col md={4}>
                        <div className="text-left mt-3">
                            <InputGroup>
                                <FormControl className="search-field" placeholder="Search by device id" value={search} onChange={(e) => handleSearch((e.target.value).trim())} />
                            </InputGroup>
                        </div>
                    </Col>
                    <Col>
                        <div className="text-right mt-3">
                            <Button onClick={() => setShow(true)}>Send Mass Notification</Button>
                        </div>
                    </Col>
                </Row>
            </div>
            <section className="section dashboard">
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>Rank</th>
                            <th>Device Id</th>
                            <th>Current Month Points</th>
                            <th>Total Points</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.length > 0 ?
                            data.map((d) =>
                                <tr>
                                    <td>{d.rank}</td>
                                    <td>{d.deviceId}</td>
                                    <td>{d.current_month_points}</td>
                                    <td>{d.total_points}</td>
                                    <td><Button onClick={() => { setDeviceToken(d.deviceToken); setCongoModal(true); }}>Send Notification</Button></td>
                                </tr>
                            ) :
                            <tr>
                                <td colSpan={5}>
                                    <h5 className="text-center">No match found</h5>
                                </td>
                            </tr>

                        }
                    </tbody>
                </Table>
                <Modal show={show} onHide={() => closeModal()}>
                    <Modal.Header closeButton>
                        <Modal.Title>Send Notification</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Select aria-label="Default select example" value={deviceToken} onChange={(e) => {setDeviceToken(e.target.value); setSelectedTimezone("all")}}>
                                <option value="">Select Users</option>
                                <option value="top1">Top 1</option>
                                <option value="top10">Top 10</option>
                                <option value="top100">Top 100</option>
                                <option value="all">All</option>
                            </Form.Select>
                            {deviceToken === "all" &&
                                <>
                                    <label className="mt-3">Select Region Timezone</label>
                                    <Form.Select aria-label="Default select example" value={selectedTimezone} onChange={(e) => setSelectedTimezone(e.target.value)}>
                                        <option value="all">All</option>
                                        {availableTimezone.map((d, i) => <option key={i} value={d}>{d}</option>)}
                                    </Form.Select>
                                </>
                            }
                            {deviceToken &&
                                <>
                                    <Form.Group className="mb-3 mt-2" controlId="exampleForm.ControlInput">
                                        <Form.Label>Title</Form.Label>
                                        <Form.Control type="text" value={title} onChange={(e) => setTitle(e.target.value)} maxLength={30} />
                                    </Form.Group>
                                    <Form.Group className="mb-3 mt-2" controlId="exampleForm.ControlTextarea1">
                                        <Form.Label>Message</Form.Label>
                                        <Form.Control as="textarea" rows={3} value={message} onChange={(e) => setMessage(e.target.value)} maxLength={350} />
                                    </Form.Group>
                                </>
                            }
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => closeModal()}>
                            Close
                        </Button>
                        {deviceToken &&
                            <Button variant="primary" onClick={() => sendMessage()}>
                                Send
                            </Button>
                        }
                    </Modal.Footer>
                </Modal>
                <Modal show={congoModal} onHide={() => closeModal()}>
                    <Modal.Header closeButton>
                        <Modal.Title>Send Notification</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group className="mb-3 mt-2" controlId="exampleForm.ControlInput">
                                <Form.Label>Title</Form.Label>
                                <Form.Control type="text" value={title} onChange={(e) => setTitle(e.target.value)} maxLength={30} />
                            </Form.Group>
                            <Form.Group className="mb-3 mt-2" controlId="exampleForm.ControlTextarea1">
                                <Form.Label>Message</Form.Label>
                                <Form.Control as="textarea" rows={3} value={message} onChange={(e) => setMessage(e.target.value)} maxLength={350} />
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => closeModal()}>
                            Close
                        </Button>
                        <Button variant="primary" onClick={() => sendMessage()}>
                            Send
                        </Button>
                    </Modal.Footer>
                </Modal>
            </section>
            {
                count > 20 &&
                <Pagination
                    activePage={page}
                    itemsCountPerPage={20}
                    totalItemsCount={count}
                    pageRangeDisplayed={5}
                    prevPageText="Previous"
                    nextPageText="Next"
                    onChange={(event) => {
                        set_page(event)
                        navigate(`/users?page=${event}`)
                    }}
                />
            }
        </main >
    )

}